<template>
  <section class="hero min-h-screen bg-base-100 py-12 md:py-20">
    <div class="hero-content flex-col lg:flex-row gap-12 lg:gap-20 w-full max-w-7xl px-4 md:px-8">
      
      <div class="text-center lg:text-left flex-1">
        <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary font-semibold mb-6">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
          Grow With Us
        </div>
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
          Take Your Restaurant to the Next Level
        </h2>
        <p class="text-lg md:text-xl mb-10 opacity-80 max-w-2xl mx-auto lg:mx-0">
          Join our multi-vendor platform to reach thousands of new customers, streamline your table management, and boost your daily revenue.
        </p>
        
        <div class="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
          <NuxtLink to="/register/merchant" class="btn btn-primary btn-lg w-full sm:w-auto px-8">
            Register Restaurant
          </NuxtLink>
          <NuxtLink to="/contact" class="btn btn-outline btn-lg w-full sm:w-auto px-8">
            Talk to Sales
          </NuxtLink>
        </div>
      </div>

      <div class="flex-1 w-full lg:max-w-lg">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          
          <div class="card bg-base-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div class="card-body p-6 text-left">
              <div class="w-12 h-12 rounded-xl bg-blue-500/10 text-blue-600 flex items-center justify-center mb-4">
                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>
              </div>
              <h3 class="font-bold text-lg mb-1">More Orders</h3>
              <p class="text-sm opacity-70">Increase your visibility and get more delivery and pickup orders.</p>
            </div>
          </div>

          <div class="card bg-base-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div class="card-body p-6 text-left">
              <div class="w-12 h-12 rounded-xl bg-emerald-500/10 text-emerald-600 flex items-center justify-center mb-4">
                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/></svg>
              </div>
              <h3 class="font-bold text-lg mb-1">QR Table Ordering</h3>
              <p class="text-sm opacity-70">Let dine-in customers order directly from their smartphones.</p>
            </div>
          </div>

          <div class="card bg-base-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div class="card-body p-6 text-left">
              <div class="w-12 h-12 rounded-xl bg-purple-500/10 text-purple-600 flex items-center justify-center mb-4">
                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>
              </div>
              <h3 class="font-bold text-lg mb-1">Fast Payouts</h3>
              <p class="text-sm opacity-70">Get your earnings deposited directly to your account rapidly.</p>
            </div>
          </div>

          <div class="card bg-base-200 shadow-sm hover:shadow-md transition-all duration-300">
            <div class="card-body p-6 text-left">
              <div class="w-12 h-12 rounded-xl bg-orange-500/10 text-orange-600 flex items-center justify-center mb-4">
                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
              </div>
              <h3 class="font-bold text-lg mb-1">24/7 Support</h3>
              <p class="text-sm opacity-70">Our dedicated merchant support team is always here to help.</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </section>
</template>